export interface Category {
  slug: string;
  name: string;
  icon: string;
  description: string;
  count: number;
}

export const categories: Category[] = [
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line', description: '甜蜜浪漫的爱情故事，感受心动时刻', count: 1280 },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line', description: '穿越异世界，探索未知的奇幻冒险', count: 960 },
  { slug: 'action', name: '动作', icon: 'ri-sword-line', description: '热血沸腾的战斗场面，紧张刺激', count: 850 },
  { slug: 'thriller', name: '悬疑', icon: 'ri-search-eye-line', description: '扣人心弦的推理剧情，烧脑解谜', count: 620 },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line', description: '轻松幽默的日常故事，笑到停不下来', count: 740 },
  { slug: 'drama', name: '剧情', icon: 'ri-film-line', description: '深刻动人的剧情佳作，引人深思', count: 890 },
  { slug: 'horror', name: '恐怖', icon: 'ri-ghost-line', description: '毛骨悚然的惊悚漫画，挑战胆量', count: 430 },
  { slug: 'bl', name: 'BL/GL', icon: 'ri-user-heart-line', description: '细腻情感描绘，独特视角的故事', count: 560 },
];